import React, { useEffect, useState, useContext, useRef } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import ConfigContext from '../ConfigContext'
import axios from 'axios'

import { Grid, Box, Paper, Typography, Button, TextField } from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'

import Title from '../components/atoms/Title'
import TextArea from '../components/atoms/TextArea'
import CenteredSubmitButton from '../components/molecules/CenteredSubmitButton'
import TinyMCE from '../components/organisms/TinyMCE'
import WebViewModal from '../components/organisms/WebViewModal'

import { Contact } from '../types/Contact'

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    height: `100%`
  },
  textField: {
    paddingRight: theme.spacing(1)
  }
}))

const EventCMS: React.FC<RouteComponentProps> = ({ history }) => {
  const classes = useStyles({})
  const [modalState, setModalState] = useState(false)
  const [contact, setContact] = useState<{
    contact_to: string
    content: string
    map_url: string
  }>({
    contact_to: '',
    content: '',
    map_url: ''
  })
  const config = useContext(ConfigContext)
  const editorRef = useRef(null)

  /**
   * 初期化処理
   */
  useEffect(() => {
    const fetchContact = async () => {
      const { data } = await axios.get<Contact>(`/contact`)
      setContact({
        contact_to: data.contact_to,
        content: data.content,
        map_url: data.map_url
      })
    }
    fetchContact()
  }, [])

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    try {
      event.preventDefault()
      await axios.put(`/contact`, contact)
      window.location.reload()
    } catch (error) {
      alert(error.message)
    }
  }

  return (
    <React.Fragment>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Title>お問い合わせ情報</Title>
          <form onSubmit={handleSubmit}>
            <Box mb={5}>
              <Grid container alignItems="center" spacing={3}>
                <Grid item xs={12} sm={2} md={1}>
                  <Typography variant="subtitle2">タイトル</Typography>
                </Grid>
                <Grid item xs={12} sm={10} md={11}>
                  <Box width={400}>
                    <TextField
                      required
                      value={contact.contact_to}
                      variant="outlined"
                      placeholder="タイトルを入力"
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                        setContact({
                          ...contact,
                          contact_to: event.target.value
                        })
                      }
                      fullWidth
                    />
                  </Box>
                </Grid>

                {/* <Grid item xs={12} sm={2} md={1}>
                  <Typography variant="subtitle2">Google Map</Typography>
                </Grid>
                <Grid item xs={12} sm={10} md={11}>
                  <TextArea
                    label="埋め込みコード"
                    value={contact.map_url}
                    variant="outlined"
                    rows={5}
                    fullWidth
                    inputHandler={input => setContact({ ...contact, map_url: input })}
                  />
                </Grid> */}
              </Grid>
            </Box>

            <Box my={3}>
              <Box>
                <TinyMCE
                  initialValue={contact.content}
                  editorRef={editorRef}
                  inputHandler={(tinyMCEContent: string) => {
                    setContact({
                      ...contact,
                      content: tinyMCEContent
                    })
                  }}
                />
              </Box>
            </Box>

            <Box my={5}>
              <Grid container justify="center" style={{ marginBottom: 15 }}>
                <Button variant="contained" color="primary" onClick={() => setModalState(true)}>
                  プレビュー
                </Button>
              </Grid>
              <Grid container justify="center">
                <Typography variant="caption">※変更内容を登録しなければ、反映されません</Typography>
              </Grid>
            </Box>

            <Box mb={10}>
              <CenteredSubmitButton
                submittable
                resettable
                submitHandler={() => {}}
                resetHandler={() => {
                  window.location.reload()
                }}
                size="large"
              />
            </Box>
          </form>
        </Paper>
      </Grid>
      <WebViewModal
        isOpen={modalState}
        handleClose={() => setModalState(false)}
        url={`${axios.defaults.baseURL}/previews/contact`}
      />
    </React.Fragment>
  )
}

export default EventCMS
